<template>
  <div id="app">
    <div v-show="isShowNavBar" class="navBar">
      <span class="back" @click="back" v-show="isShow_hiddenBack">
        <van-icon name="arrow-left" />
      </span>
      <span class="navTitle">{{navTitle}}</span>
    </div>
    <div :class="isShowNavBar?'app-container pt':'app-container'">
      <!-- <transition name="fade" mode="out-in">
          <keep-alive :include="/transactionList|operatorInfo/">
            <router-view />
          </keep-alive>
      </transition> -->
      <navigation>
        <router-view></router-view>
      </navigation>
    </div>
  </div>
</template>


<script>
export default {
  name: 'app',
  data(){
    return {
      isShow_hiddenBack:true,
      isShowNavBar:true,
      navTitle:''
    }
  },
  created(){
    
  },
  mounted(){

  },
  methods:{
    back(){
      this.$router.go(-1);
    }
  },
  watch:{
    $route(to,from){ 
      this.isShowNavBar = !to.meta.hidden;
      this.isShow_hiddenBack = !to.meta.hiddenBack;
      this.navTitle = to.meta.title;
    }
  },
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  .app-container{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    font-size: 0.28rem;
    background-color: #fff;
  }
  .pt{
    padding-top: 0.88rem;
  }
}
.ellipsis-1{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fwb{
  font-weight: bold;
}
input{
  -webkit-tap-highlight-color:transparent;
  -webkit-appearance: none;
}
em{
  font-style: normal;
}

.navBar{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width:100%;
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  font-family:PingFang SC;
  background-color: #fff;
  text-align: center;
  // background-color: #0db09b;
  box-shadow:0rem 0.02rem 0.03rem 0rem #ddd;
  font-size: 0.36rem;
  // color: #fafafa;
  .back{
    width: 0.36rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .navTitle{
    width: 5.5rem;
    font-weight: bold;
    position: absolute;
    left: 1rem; 
    transition: 0.5s all;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
